<template>
    <div class="db-breadcrumb flex items-center justify-between gap-4">
        <ul class="db-breadcrumb-list">
            <li v-if="Object.keys(authDefaultPermission).length > 0" class="db-breadcrumb-item">
                <router-link class="db-breadcrumb-link" :to="'/admin/'+authDefaultPermission.url">
                    {{ $t('menu.'+authDefaultPermission.name) }}
                </router-link>
            </li>
            <li class="db-breadcrumb-item" v-for="(val, key) in breadcrumbs" :key="val.name || val.path || key">
                <span v-if="key !== breadcrumbs.length - 1">
                    <router-link class="db-breadcrumb-link" :to="val.to">
                        {{ breadcrumbText(val) }}
                    </router-link>
                </span>
                <span v-else>
                    {{ breadcrumbText(val) }}
                </span>
            </li>
        </ul>
        <button type="button" class="db-btn py-1 px-3 bg-white border border-gray-200 hover:bg-gray-50"
            @click="goBack">
            <i class="fa-solid fa-arrow-left mr-1"></i>
            <span>{{ $t('button.back') }}</span>
        </button>
    </div>
</template>

<script>
export default {
    name: "BreadcrumbComponent",
    data() {
        return {
            breadcrumbs: []
        }
    },
    computed: {
        authDefaultPermission: function () {
            return this.$store.getters.authDefaultPermission;
        },
        aiImportShow: function () {
            return this.$store.getters['aiImport/show'] || {};
        }
    },
    watch: {
        $route() {
            this.route();
        }
    },
    created() {
        this.route();
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        breadcrumbText(record) {
            if (record?.name === 'admin.products.aiImport.show' && this.aiImportShow?.code) {
                return this.$t('menu.ai_import_batch', { code: this.aiImportShow.code });
            }

            return this.$t('menu.' + record.meta.breadcrumb);
        },
        extractParamsByPath(path) {
            const params = {};
            const matches = String(path || '').match(/:([^/]+)/g) || [];

            matches.forEach((match) => {
                const key = match.replace(':', '').replace('?', '');
                if (typeof this.$route.params[key] !== 'undefined') {
                    params[key] = this.$route.params[key];
                }
            });

            return params;
        },
        resolveBreadcrumbTarget(record) {
            if (!record?.name) {
                return record?.path || '/';
            }

            return {
                name: record.name,
                params: this.extractParamsByPath(record.path),
            };
        },
        route: function () {
            const matched = (this.$route.matched || []).filter((item) => item?.meta?.breadcrumb);
            const breadcrumbItems = matched.map((record) => ({
                ...record,
                to: this.resolveBreadcrumbTarget(record),
            }));

            if (this.$route.name === 'admin.products.aiImport.show') {
                const hasAiImportNode = breadcrumbItems.some((item) => item.name === 'admin.products.aiImport');
                if (!hasAiImportNode) {
                    const showIndex = breadcrumbItems.findIndex((item) => item.name === 'admin.products.aiImport.show');
                    const aiImportNode = {
                        name: 'admin.products.aiImport',
                        path: '/admin/productos/importacion-ia',
                        meta: {
                            breadcrumb: 'ai_imports',
                        },
                        to: {
                            name: 'admin.products.aiImport',
                        },
                    };

                    if (showIndex >= 0) {
                        breadcrumbItems.splice(showIndex, 0, aiImportNode);
                    } else {
                        breadcrumbItems.push(aiImportNode);
                    }
                }
            }

            this.breadcrumbs = breadcrumbItems;
        }
    }
}
</script>

<style scoped>

</style>
